// extracted by mini-css-extract-plugin
export var adjacentSlide = "_q4-9";
export var arrowButtonContainer = "_q4-5";
export var arrowButtonIcon = "_q4-6";
export var carouselArrowButton = "_q4-2";
export var carouselElementContainer = "_q4-1";
export var currentSlide = "_q4-8";
export var left = "_q4-3";
export var otherSlide = "_q4-a";
export var productCarouselContainer = "_q4-0";
export var right = "_q4-4";
export var sliderOverflow = "_q4-7";